import { TextField } from "@mui/material";
import { Field, useFormikContext } from "formik";

const ProfileFormInput = ({ name, ...rest }: any) => {
  const { errors, touched } = useFormikContext<any>(); // Use Formik context

  return (
    <Field
      name={name}
      as={TextField}
      error={Boolean(errors?.[name] && touched?.[name])} // Safely access errors and touched
      helperText={errors?.[name] && touched?.[name] ? errors[name] : ""}
      InputProps={{
        sx: {
          height: 36,
          '& input': {
            height: '36px',
            padding: '0 10px',
          },
        },
      }}
      {...rest}
    />
  );
};

export default ProfileFormInput;
